import React from 'react';
import ModalFormUI from '../../../widgets/form/ModalFormUI';
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF';
import InputTextSF from '../../../widgets/form/InputTextSF';
const MessageCreateModalUI = ({
  context, successMsg, errorList, setErrorList, submitted,
  messageCreateMode, onSubmit, onCancelClick,
  subject, onSubjectChange, subjectError, setSubjectError,
  emailTo, onEmailToChange, emailToError, setEmailToError,
  emailCc, onEmailCcChange, emailCcError, setEmailCcError,
  emailBcc, onEmailBccChange, emailBccError, setEmailBccError,
  message, onMessageChange, messageError, setMessageError,
}) => {
  return (
    <ModalFormUI
      context={context}
      titleLabel="Create New Message (This is for testing purpose only)"
      buttonLabel="Create"
      cancelLabel="Cancel"
      isOpen={messageCreateMode}
      onRequestClose={onCancelClick}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSubmit}
      busy={submitted}
    >
      <InputTextSF type="text" name="subject" label="Subject"
        maxLength={200} required={true} value={subject}
        onChange={onSubjectChange} error={subjectError} setError={setSubjectError}
      />
      <InputTextSF type="text" name="emailTo" label="To"
        maxLength={200} required={true} value={emailTo}
        onChange={onEmailToChange} error={emailToError} setError={setEmailToError}
      />
      <InputTextSF type="text" name="emailCc" label="Cc"
        maxLength={200} value={emailCc}
        onChange={onEmailCcChange} error={emailCcError} setError={setEmailCcError}
      />
      <InputTextSF type="text" name="emailBcc" label="Bcc"
        maxLength={200} value={emailBcc}
        onChange={onEmailBccChange} error={emailBccError} setError={setEmailBccError}
      />
      <InputTextSF type="text" name="message" label="Message"
        maxLength={2000} required={true} value={message}
        onChange={onMessageChange} error={messageError} setError={setMessageError}
      />
    </ModalFormUI>
  );
};

export default MessageCreateModalUI;